
export function valueHasChanged(obj={}){

	const changedFrom = obj.changedFrom;

	const value_fromSlider = $("."+this.rangeInputClass).val();

	//console.log(value_fromSlider+" from slider");

	const value_fromInput = $("."+this.editableInputClass).val();

	let value = value_fromSlider;

	if(changedFrom == "input"){

		value = value_fromInput;

	};

	//const value = $("."+this.rangeInputClass).val();

	if(this.isEmpty(value)){

		value = this.defaultValue;

	};

	if(value > this.max){

		value = this.max;
		
	}else if(value < this.min){

		value = this.min;

	};

	if(changedFrom != "slider"){

		$("."+this.rangeInputClass).val(value);

	};

	$("."+this.editableInputClass).val(value);

	$("."+this.editableInputClass).trigger("focusout");

	
	if( !this.onChangeFunc || !$.isFunction(this.onChangeFunc) ){

		return false;

	};

	//console.log(value+" before function");

	this.onChangeFunc({
		value: value,
		unit: this.unit,
		property: this.property,
		defaultValue:this.defaultValue, 
		storageObj: this.storageObj
	});

	//return false;

};